<div class="container mt-3">
    <div class="mw530">
        <ng-container *ngIf="documents.length > 0">
            <ng-container *ngFor="let document of documents; let i = index">        
                <div class="icon" (click)="toggleCollapse(i)"
                [attr.aria-expanded]="isCollapsed[i] ? true : false" [attr.aria-controls]="'collapse-' + i">
                    <span class="overview-icons new">
                        <i [class]="isCollapsed[i] ? 'fas fa-plus' : 'fas fa-minus'"></i>
                    </span>
                    <h2 class="title">{{document.name}}</h2>
                </div>
                <ul class="list-documents" id="collapse-{{i}}" [ngbCollapse]="isCollapsed[i]" [attr.aria-labelledby]="'heading-'+i">
                    <ng-container *ngFor="let file of document.files">
                        <li><i class="fas fa-file"></i> <a [href]="file.url" target="_blank">{{file.name}}</a></li>
                    </ng-container>
                </ul>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="pdfItems.length > 0">
            <div class="icon" aria-expanded="false" aria-controls="collapse-0">
                <span class="overview-icons new"><i class="fas fa-minus"></i></span>
                <h2 class="title">{{ "HOME.PDFTITLE" | translate }}</h2>
            </div>
            <ul class="list-documents collapse show" ng-reflect-collapsed="false" id="collapse-0" aria-labelledby="heading-0">
                <ng-container *ngFor="let item of pdfItems">
                    <li>
                        <i class="fas fa-file"></i>
                        <a target="_blank" [href]="item">
                            {{ returnTitle(item) }}
                        </a>
                    </li>
                </ng-container>
            </ul>
        </ng-container>
    </div>
</div>